// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"20e72670","815":"bd5e0fe2","879":"85a391f1"}[chunkId] + ".chunk.js";
};